import { QuickstartThankYouRedirect } from './QuickstartThankYouRedirect';
import { QuickstartTheme } from '../types/theme';

interface QuickstartErrorProps {
  theme: QuickstartTheme;
  message?: string;
  onRetry?: () => void;
  onWishlistCTAClicked?: () => void;
}

/**
 * QuickstartError Component
 *
 * Now renders the same thank you page regardless of error.
 * All errors redirect to Steam.
 *
 * Note: This component simply wraps QuickstartThankYouRedirect to avoid code duplication.
 */
export const QuickstartError = ({ theme, onWishlistCTAClicked }: QuickstartErrorProps) => {
  return <QuickstartThankYouRedirect theme={theme} onRedirect={onWishlistCTAClicked} />;
};
